import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Data Not found
      </Typography>
      <Typography variant="body2" align="center">
        No data found in List for &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Add Data After Show Your List.
      </Typography>
    </Paper>
  );
}
